import React from 'react';
import { Link } from 'react-router-dom';

export const WorkOrderOriginLink = ({ record, testId }) => record?.source_work_order_id && (record.machinery_id || record.source_machinery_id)
  ? <Link data-testid={testId} className="text-xs text-blue-700 underline break-words"
      to={`/machinery/${record.machinery_id || record.source_machinery_id}?workOrder=${record.source_work_order_id}`}>
      From service {record.source_work_order_number ? `#${record.source_work_order_number} · ` : ''}{record.source_work_order_title || 'Work order'} →
    </Link> : null;